// extracted by mini-css-extract-plugin
export default {"chevronUp":"chevron-up","chevronDown":"chevron-down","chevronLeft":"chevron-left","chevronRight":"chevron-right","times":"times","check":"check"};